"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Talend = function Talend(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.2822 7.6735c-.845 0-1.6054.2958-2.2392.7605l-4.6472-5.7035.0422-.0422c.2958-.3802.2113-.9295-.169-1.2252-.3802-.2957-.9294-.2112-1.2252.169-.2957.3802-.2112.9295.169 1.2252.2958.2112.676.2112.9717.0845l4.6473 5.7035c-.338.2957-.6337.676-.845 1.0561L3.7632 3.5755c.0845-.2957.1268-.5915.0845-.8872-.0845-.507-.338-.9717-.7604-1.2674-.4225-.2958-.9295-.4225-1.4364-.3803-.507.0845-.9718.338-1.2675.7605-.6337.845-.4647 2.0701.3802 2.7039.338.2534.7605.3802 1.1407.3802h.2535c.507-.0845.9717-.338 1.2675-.7605.0422-.0845.1267-.169.169-.2535L16.8179 9.955c-.169.3803-.2535.8027-.2958 1.2675H5.3264c-.0422-.2958-.2112-.5915-.4647-.8027-.507-.3803-1.2674-.2958-1.6477.2112-.3802.507-.2957 1.2674.2535 1.6477.507.3802 1.2674.2957 1.6477-.2113.1267-.169.2112-.3802.2112-.5492h11.238c0 .4647.1267.9295.338 1.352l-2.873 1.3941c-.0844-.1267-.2534-.2535-.5069-.2957-.4647-.1268-.9717.2112-1.0562.676-.1267.4647.2113.9717.676 1.0562.4647.1267.9717-.2113 1.0562-.676.0422-.169.0422-.2957 0-.4647l2.8728-1.3942c.2535.4225.5915.845.9717 1.1407l-3.7178 5.112c-.3802-.2535-.845-.3803-1.352-.2958-.5069.0845-.9716.338-1.2673.7605-.6338.845-.4648 2.0701.3802 2.7039.338.2535.7604.3802 1.1407.3802h.2535c.507-.0845.9717-.338 1.2674-.7605.2957-.4224.4225-.9294.3802-1.4364-.0422-.4647-.2535-.845-.5914-1.1407l3.7178-5.112c.5915.3802 1.2674.5915 2.0279.5915C22.31 15.1092 24 13.4615 24 11.3914c0-2.0702-1.69-3.7179-3.7178-3.7179M3.214 3.9557c-.2535.338-.6337.5493-1.0562.6338-.4225.0422-.845-.0423-1.183-.2958C.2568 3.7445.13 2.7305.637 2.0123c.2535-.3802.6337-.5914 1.0562-.676h.2112c.338 0 .676.1268.9717.338.3803.2535.5915.6338.676 1.0562.0423.4225-.0845.8872-.338 1.2252m11.3225 17.9976c-.2535.338-.6338.5915-1.0562.6338-.4225.0422-.845-.0423-1.183-.2958-.7182-.5492-.845-1.5631-.338-2.2814.2535-.338.6338-.5492 1.0562-.6337h.2113c.338 0 .676.1268.9717.338.338.2535.5492.6337.6337 1.0562.0845.4225-.0422.845-.2957 1.183Z"
  }));
};

Talend.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes["default"].string,

  /**
   * The size of the Icon.
   */
  size: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
Talend.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Talend;
exports["default"] = _default;